export const SET_SESSION_LIST = "SET_SESSION_LIST";
